var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPause = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "pause_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  mask: "url(#pause_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 6.5C12.544 6.5 6.5 12.544 6.5 20S12.544 33.5 20 33.5 33.5 27.456 33.5 20 27.456 6.5 20 6.5ZM3.5 20c0-9.113 7.387-16.5 16.5-16.5S36.5 10.887 36.5 20 29.113 36.5 20 36.5 3.5 29.113 3.5 20Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 26V14h3v12h-3ZM22 26V14h3v12h-3Z"
}))));
export default SvgPause;